// extracted by mini-css-extract-plugin
export default {"blueBorderBlock":"Whyimporc_blueBorderBlock__Y9C++","heading":"Whyimporc_heading__inIkD","content":"Whyimporc_content__o1980"};